import PropTypes from 'prop-types'
import React from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikTextField,
  FormikSelect,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import { useAdmin } from '../hooks'

const mapToOption = ({ id, name }) => ({ value: id, label: name })

const UsersForm = () => {
  const { roles, purchasingEnvironments } = useAdmin()
  console.debug('roles', roles)
  console.debug('purchasingEnvironments', purchasingEnvironments)
  return (
    <Form>
      <FormikTextField
        fullWidth
        label="First name"
        margin="normal"
        name="firstName"
        type="text"
      />
      <FormikTextField
        fullWidth
        label="Last Name"
        margin="normal"
        name="lastName"
        type="text"
      />
      <FormikTextField
        fullWidth
        label="Email"
        margin="normal"
        name="email"
        type="text"
      />
      <FormikTextField
        fullWidth
        label="Job title"
        margin="normal"
        name="jobTitle"
        type="text"
      />
      <FormikSelect
        fullWidth
        label="Role"
        margin="normal"
        name="role"
        options={
          roles && Array.isArray(roles) ? [...roles.map(mapToOption)] : []
        }
      />
      <FormikSelect
        multiple
        type="select-multiple"
        fullWidth
        label="Purchasing environments - optional"
        margin="normal"
        name="environments"
        options={
          purchasingEnvironments && Array.isArray(purchasingEnvironments)
            ? [...purchasingEnvironments.map(mapToOption)]
            : [...purchasingEnvironments.results.map(mapToOption)]
        }
      />
    </Form>
  )
}

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required(FIELD_REQUIRED),
  lastName: Yup.string().required(FIELD_REQUIRED),
  email: Yup.string().email().required(FIELD_REQUIRED),
  jobTitle: Yup.string().required(FIELD_REQUIRED),
  role: Yup.number().required(FIELD_REQUIRED),
})

export const AddUsersModal = ({ ...props }) => {
  const { addUsers } = useAdmin()

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    jobTitle: '',
    role: '',
    environments: [],
  }

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={values => addUsers(values)}
      submitText="Add"
      successNotification={{
        image: 'carrots',
        message:
          "User created!\n\nWe're ready and sure your users are going to have fun on here.",
      }}
      title="Add User"
      validationSchema={validationSchema}
      {...props}
    >
      <UsersForm />
    </FormikDialog>
  )
}

AddUsersModal.propTypes = {
  trigger: PropTypes.func,
}

export const EditUsersModal = ({ user, ...props }) => {
  const { updateUsers } = useAdmin()

  const initialValues = { ...user, role: user.role || '' }

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={values => updateUsers(values)}
      submitText="Update"
      successNotification={{
        image: 'carrots',
        message: 'User updated!',
      }}
      title="Edit User"
      validationSchema={validationSchema}
      {...props}
    >
      <UsersForm />
    </FormikDialog>
  )
}

EditUsersModal.propTypes = {
  trigger: PropTypes.func,
}
